import type { FC } from 'react';
import { Card, Modal } from '..';
import * as Styled from './styled';
import type { MtBookingUpdateModalProps } from './types';

export * from './types';

export const MtBookingUpdateModal: FC<MtBookingUpdateModalProps> = (props) => {
  const { modal, slotPickerComponent } = props;

  return (
    <Modal {...modal}>
      <Card size="small" noPadding isModal>
        <Styled.StyledModalCloseButton modal={modal} />
        {slotPickerComponent}
      </Card>
    </Modal>
  );
};
